import { render, staticRenderFns } from "./ListBase.vue?vue&type=template&id=9d8db972&scoped=true&"
import script from "./ListBase.vue?vue&type=script&lang=js&"
export * from "./ListBase.vue?vue&type=script&lang=js&"
import style0 from "./ListBase.vue?vue&type=style&index=0&id=9d8db972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8db972",
  null
  
)

export default component.exports